import React from "react";
import { useTranslation } from "react-i18next";

import { legendItemStyle, legendStyle } from "./style";

export const hailITALargeLegendPerLevel = (t, level) => {
  return [
    `${t("levels.noData")} : (ph < 0)`,
    `${t("levels.low")} : (0 ≤ ph < 0.005)`,
    `${t("levels.moderate")} : (0.005 ≤ ph < 0.0125)`,
    `${t("levels.significant")} : (0.0125 ≤ ph < 0.02)`,
    `${t("levels.high")} : (ph ≥ 0.02)`,
  ][level];
};

export const hailITALargeLegendLevels = () => {
  return [0, 0.005, 0.0125, 0.02, 1];
  // 4 numerical intervals for normal legend (1,2,3,4)
  // Other values are considered as "no data"
};

const HailITALargeLegend = () => {
  const { t } = useTranslation();

  return (
    <div style={legendStyle}>
      <div>
        <b>{t("riskAssessment.hail")} (ITA) - Large</b>
      </div>
      <div>
        <span style={legendItemStyle("#f0e5ee")}></span>
        {hailITALargeLegendPerLevel(t, 1)}
      </div>
      <div>
        <span style={legendItemStyle("#d4c1d4")}></span>
        {hailITALargeLegendPerLevel(t, 2)}
      </div>
      <div>
        <span style={legendItemStyle("#b295b4")}></span>
        {hailITALargeLegendPerLevel(t, 3)}
      </div>
      <div>
        <span style={legendItemStyle("#8b638f")}></span>
        {hailITALargeLegendPerLevel(t, 4)}
      </div>
      <div>
        <span
          style={{
            marginTop: 10,
            fontSize: "x-small",
            display: "block",
            float: "left",
            width: "200px",
            lineHeight: 1,
          }}
        >
          ph = {t("legend.hailAnnualProbability")} (&gt; 20mm diameter)
        </span>
      </div>
      <div>
        <span
          style={{
            marginTop: 10,
            fontSize: "xx-small",
            display: "block",
            float: "left",
            width: "200px",
            lineHeight: 1,
          }}
        >
          © CyStellar, {t("legend.dataFromRAIN")}
        </span>
      </div>
    </div>
  );
};

export default HailITALargeLegend;
